export default __webpack_public_path__ + "images/ZK.936611c.png";